import { combineReducers } from "redux";
import appReducer from "../app/appReducer";
import cartReducer from "../cart/cartReducer";
import categoriesReducer from "../categories/categoriesReducer";
import deliveryReducer from "../delivery/deliveryReducer";
import authReducer from "../reducers/authReducer";
import categoryReducer from "../reducers/categoryReducer";
import menuReducer from "../reducers/menuReducer";
import orderReducer from "../reducers/orderReducer";
import paymentReducer from "../reducers/paymentReducer";
import shopReducer from "../reducers/shopReducer";
import viewReducer from "../reducers/viewReducer";

// const persistedReducers = {
//   cart: persistReducer(cartPersistConfig, cartReducer),
//   auth: persistReducer(authPersistConfig, authReducer),
//   delivery: persistReducer(deliveryPersistConfig, deliveryReducer as any),
// };

const rootReducer = combineReducers({
  // ...persistedReducers,

  cart: cartReducer,
  auth: authReducer,
  delivery: deliveryReducer,
  view: viewReducer,
  shop: shopReducer,
  category: categoryReducer,
  menu: menuReducer,
  order: orderReducer,
  payment: paymentReducer,
  categories: categoriesReducer,
  app: appReducer
});

export default rootReducer;
